import { ApolloLink } from '@apollo/client';

export const requestDurationLink = new ApolloLink((operation, forward) => {
    operation.setContext({ startTime: performance.now() });
    return forward(operation);
});
